import React, {ReactElement} from 'react';

import Tooltip from 'src/components/tooltip';

interface Props {
  children: ReactElement;
}

const NewTabTooltip = ({children}: Props) => <Tooltip title="Opens in new tab">{children}</Tooltip>;

export default NewTabTooltip;
